module.exports = __webpack_public_path__ + "media/stylesheets/images/media/folk_bg-b642a0ad1d9aaff5b820f0754416ddb8.jpg";